var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.size === "small"
    ? _c(
        "svg",
        {
          staticClass: "spinner",
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            height: "30",
            width: "60",
          },
        },
        [
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "15", cy: "17", r: "4" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.1",
                },
              }),
            ]
          ),
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "27", cy: "17", r: "4" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.2",
                },
              }),
            ]
          ),
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "38", cy: "17", r: "4" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.3",
                },
              }),
            ]
          ),
        ]
      )
    : _c(
        "svg",
        {
          staticClass: "spinner",
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            height: "30",
            width: "60",
          },
        },
        [
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "6", cy: "15", r: "6" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.1",
                },
              }),
            ]
          ),
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "26", cy: "15", r: "6" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.2",
                },
              }),
            ]
          ),
          _c(
            "circle",
            { attrs: { stroke: "none", cx: "46", cy: "15", r: "6" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "opacity",
                  dur: "1s",
                  values: "0;1;0",
                  repeatCount: "indefinite",
                  begin: "0.3",
                },
              }),
            ]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }